import React, { useState } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import { AlertTriangle } from 'lucide-react';

const CancelSessionModal = ({ isOpen, onClose, onConfirm, session, isLoading }) => {
    const [reason, setReason] = useState('Member Request');

    const handleSubmit = () => {
        // if (!reason) {
        //     toast.error('Please select a reason for cancellation.');
        //     return;
        // }
        onConfirm(session);
    };
    const sessionStart = new Date(`${session?.date} ${session?.start_time}`);
    const now = new Date();
    const diffMinutes = (sessionStart - now) / (1000 * 60);
    const isWithin60Minutes = diffMinutes <= 60; 

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Cancel Session">
            <div className="space-y-4">
                <p className="text-gray-600">
                    Are you sure you want to cancel the session for <strong>{session?.memberName}</strong> on {new Date(session?.date).toLocaleDateString()} {session?.start_time}-{session?.end_time}?
                </p>
                {/* 60-minute rule message */}
                {isWithin60Minutes && (
                    <p className="text-red-600 font-medium ">
                       If you cancel within 60 minutes of the session start time, it will be counted as attended.
                    </p>
                )}

                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Keep Session</button>
                    <button disabled={isLoading} type="button" onClick={handleSubmit} className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading...' : 'Confirm Cancellation'}</button>
                </div>
            </div>
        </Modal>
    );
};

export default CancelSessionModal;
